import React from 'react';

import * as S from './styles';

type EmptyListProps = {
  icon: React.ReactNode;
  text: string;
};

const EmptyList = (props: EmptyListProps) => (
  <S.Empty>
    <div>{props.text}</div>
    <S.EmptyIcon>{props.icon}</S.EmptyIcon>
  </S.Empty>
);

EmptyList.defaultProps = {
  icon: '',
  text: '',
};

export default EmptyList;
